<template>
  <div>
    <label class="form-control-label">
      <h4>Max Reward Per Store <span>(baht, max 1000000)</span></h4>
    </label>
    <input
      ref="max_reward_per_store"
      v-model="max_reward_per_store"
      type="number"
      min="0"
      max="1000000"
      @change="update"
      :disabled="!canEdit"
      class="form-control"
      name="max_reward_per_store"
    />
  </div>
</template>

<script>
import { wsgtdriveService } from "@/api/client";

export default {
  props: ["campaign"],

  data() {
    return {
      id: null,
      max_reward_per_store: null,
    };
  },

  computed: {
    canEdit() {
      return ["draft", "ongoing"].includes(this.campaign.status);
    },
  },

  mounted() {
    this.id = this.campaign.id;
    this.max_reward_per_store = this.campaign.max_reward_per_store;
  },

  methods: {
    async update() {
      // Validate the range
      if (
        this.max_reward_per_store < 0 ||
        this.max_reward_per_store > 1000000
      ) {
        this.$notify({
          type: "error",
          title: "Invalid Value",
          text: "Max reward per store must be between 0 and 1,000,000 baht.",
        });
        // Reset to previous valid value
        this.max_reward_per_store = this.campaign.max_reward_per_store;
        return;
      }

      try {
        await wsgtdriveService.updateCampaignInfo(this.campaign.id, {
          max_reward_per_store: this.max_reward_per_store,
        });

        this.$notify({
          type: "success",
          title: "Updated",
          text: "Max reward per store updated successfully.",
        });
      } catch (error) {
        this.$notify({
          type: "error",
          title: "Error",
          text: "Failed to update max reward per store.",
        });
        // Reset to previous valid value on error
        this.max_reward_per_store = this.campaign.max_reward_per_store;
      }
    },
  },
};
</script>

<style scoped>
label h4 span {
  font-size: 14px;
  font-weight: 400;
}

[name="max_reward_per_store"] {
  max-width: 200px;
}
</style>
